module.exports = __webpack_public_path__ + "static/images/logo-v2-header.1Dob7xN.svg";